import Step from 'shepherd.js/src/types/step';
import { TourSteps } from './interface/tour-steps.interface';

export const createAppointmentFromHomeStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'newAppointmentStep1',
        title: 'Agenda tu primera cita',
        text: `Da clic en el botón para comenzar a agendar una cita. No te preocupes si no tienes todos los datos ahora, para fines demostrativos del tour vamos a crear una cita DEMO, la cita será eliminada al terminar el tour.`,
        attachTo: {
          element: '.btn-add-appointment',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-appointment',
          event: 'click'
        },
        buttons: [
          {
            ...buttons.cancel,
          }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byId('btn-add-appointment').subscribe({
              complete: () => {
                resolve(true);
              }
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'newAppointmentStep2',
        title: 'Tipo de cita',
        text: `Puedes elegir entre una cita presencial o una cita en línea, selecciona la opción para continuar.`,
        attachTo: {
          element: '.appointment-type-0',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.appointment-type',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'newAppointmentStep3',
        title: 'Motivo de la cita',
        text: `Puedes agregar un motivo por el cual se llevará a cabo la cita. Este valor no es requerido y para fines del tour omitiremos este paso. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.appointment-goal',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'newAppointmentStep4',
        title: 'Objetivos clínicos',
        text: `Puedes agregar uno o varios objetivos clínicos para el paciente, sin embargo, no es requerido y para fines del tour vamos a omitir este paso. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.select-objectives',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'newAppointmentStep5',
        title: 'Paciente',
        text: `Abre la lista de pacientes. Da clic para continuar.`,
        attachTo: {
          element: '.modal-add-new-assistant',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.modal-add-new-assistant',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
        classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
      },
      {
        ...steps.default,
        id: 'newAppointmentStep6',
        title: 'Paciente',
        text: `Elige al paciente con quien se agendará la cita. Para fines del tour solo debes dar clic para continuar.`,
        attachTo: {
          element: '.assistant-0',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.assistant-0',
          event: 'click'
        },
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout(() => {
              resolve(true);
            }, 1500);
          });
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'newAppointmentStep7',
        title: 'Paciente',
        text: `Da clic en el botón para continuar con el proceso.`,
        attachTo: {
          element: '.btn-add-assistant',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-assistant',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'newAppointmentStep8',
        title: 'Sucursal',
        text: `Puedes seleccionar la sucursal en la cual el paciente tomará la cita. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.select-branch',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.select-branch',
          event: 'click'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'newAppointmentStep9',
        title: 'Fecha de la cita',
        text: `Puedes seleccionar la fecha en la que se llevará a cabo la cita, además puedes elegir entre bloques predeterminados de fecha. Da clic para continuar.`,
        attachTo: {
          element: '.block-date-4',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.block-date-4',
          event: 'click'
        },
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout(() => {
              resolve(true);
            }, 1000);
          });
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'newAppointmentStep10',
        title: 'Disponibilidad para la cita',
        text: `Puedes seleccionar el horario en el cual se llevará a cabo la cita, para esto se toma en cuenta la disponibilidad de horario del experto. Para fines del tour no es necesario que selecciones el horario. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.availability-section',
          on: 'top'
        },
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout(() => {
              resolve(true);
            }, 1000);
          });
        },
        canClickTarget: false,
        classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
      },
    ];
  };
